/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TopicsInputs */

const en_topics = /** @type {(inputs: TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`topics`)
};

const nl_topics = /** @type {(inputs: TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`onderwerpen`)
};

/**
* | output |
* | --- |
* | "topics" |
*
* @param {TopicsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const topics = /** @type {((inputs?: TopicsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TopicsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_topics(inputs)
	return en_topics(inputs)
});